import { Spin } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components'

const MainDiv = styled.div`
    height: 100vh;
    width: 100%;
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    margin-top: 3rem;
`


const FullHeightLoader: FC = () => {
    return(
        <>
            <MainDiv>
                <Spin />
            </MainDiv>
        </>
    )
}
export default FullHeightLoader;